<template>
	<div class="login">
		<b-modal
      ref="loginModal"
      id="login-modal" title="INICIA SESIÓN" text-center="true" no-stacking>
      <b-container fluid>
        <b-form @submit="onSubmit" @reset="onReset" >
          <b-form-group id="email-group" label="Correo electrónico" label-for="email">
            <b-form-input @click.right.prevent @copy.prevent @paste.prevent id="email" v-model="user.email" type="email" required placeholder="tu-correo@mail.com"></b-form-input>
          </b-form-group>
          <b-form-group id="password-group" label="Contraseña" label-for="password">
            <b-form-input id="password" v-model="user.password" type="password" placeholder="******" required></b-form-input>
          </b-form-group>
          <b-form-group class="text-center">
          <b-button class="btn text-light" type="submit" style="background: #0F182B; font-weight:bold; width: 175px; height: 40px;">
            INGRESAR
          </b-button>
          </b-form-group>
        </b-form>
      </b-container>
      <template v-slot:modal-footer>
        <div class="w-100 text-center text-light" > 
				¿Ya te registraste, hijo? Si todavia no lo has hecho, hazlo <b-link variant="link" v-b-modal.register-modal class="text-light p-0" style="font-weight: bold; font-size: 16px;">aquí.</b-link>
		</div>
		<!-- Recuperar contraseña -->
		<div class="w-100 text-center text-light" > 
				¿No recuerdas tu contraseña? Recupérala <b-link variant="link" v-b-modal.reset-modal class="text-light p-0" style="font-weight: bold; font-size: 16px;">aquí.</b-link>
		</div>
      </template>
    </b-modal>
  </div>
		<!--b-modal id="login-modal" title="Inicia sesíon" v-if="show" hide-footer>
			<b-form @submit="onSubmit" @reset="onReset" >
				<b-form-group id="email-group" label="Correo electrónico" label-for="email">
					<b-form-input id="email" v-model="user.email" type="email" required placeholder="ejemplo@mail.com"></b-form-input>
				</b-form-group>
				<b-form-group id="password-group" label="Contraseña" label-for="password">
					<b-form-input id="password" v-model="user.password" type="password" placeholder="******" required></b-form-input>
				</b-form-group>
				 <b-form-group class="text-center">
				<b-button class="btn text-light" type="submit" style="background: #0F182B; font-weight:bold; width: 175px; height: 40px;">
					INGRESAR
				</b-button>
				</b-form-group>
</b-form>
      <template v-slot:modal-footer>
        <div class="w-100 text-center text-light" > 
				¿Ya te registraste, hijo? Si todavia no lo has hecho, hazlo <b-link v-b-modal.register-modal class="text-light" style="font-weight: bold;">aquí.</b-link>
			</div>
			
		</b-modal--><!-- #login-modal -->
	</div>
</template>

<script>
import { eventBus } from "./../events.js";

const axios = require("axios");
export default {
  name: "LoginForm",
  data() {
    return {
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
      user: {
        email: "",
        password: "",
      },
      show: true,
      variants: [
        "blue-dark-1",
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "info",
        "light",
        "dark",
        "blue-dark",
      ],
      headerBgVariant: "dark",
      headerTextVariant: "light",
      bodyBgVariant: "light",
      bodyTextVariant: "dark",
      footerBgVariant: "blue-dark-1",
      footerTextVariant: "dark",
      productSubscription: null,
    };
  },
  methods: {
    onSubmit: function (evt) {
      evt.preventDefault();
      if ($cookies.isKey("ctoken")) {
        axios({
          method: "POST",
          url: this.api_url + "/subscribers/login",
          data: {
            email: this.user.email,
            password: this.user.password,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("ctoken"),
          },
        }).then((response) => {
            var today = new Date();
            console.log(response);
            console.info("Se obtuvo el token del usuario");
            if (response.data.is_logged) {
              this.$snotify.success(response.data.response);
              this.show = false;
              //$cookies.set('utoken', response.data.token, today.getTime() + 3600000*24*7, '/', null, true, 'Lax');
              $cookies.set(
                "utoken",
                response.data.token,
                today.getTime() + 3600000 * 24 * 7
              );
              $cookies.set(
                "uidmmkg",
                response.data.user.id,
                today.getTime() + 3600000 * 24 * 7
              );
              eventBus.$emit("tokenSet", response.data.token);
              // Si hay productos en el carrito local, se obtienen y se agregan en bd
              if(this.productSubscription != null){
                this.$router.push({name: "checkoutSubscription", params: this.productSubscription});
                this.$store.commit('addProductCartSubscription', this.productSubscription);
              }
              else{
                this.$router.go();
              }
            } else {
              this.$snotify.warning(response.data.response);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.$snotify.info("No se ha podido registrar al usuario");
      }
    },
    onReset: function (evt) {
      evt.preventDefault();
      console.info("Reseteando");
    },
    showModal(param){
      this.$refs.loginModal.show();
      this.productSubscription = param;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
